import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Spinner } from "reactstrap";

//import images
import logoSm from "../assets/images/logo-sm.png";
import logoDark from "../assets/images/logo-dark.png";
import logoLight from "../assets/images/logo-light.png";

//import Components
import SearchOption from "../Components/Common/SearchOption";
import LanguageDropdown from "../Components/Common/LanguageDropdown";
import WebAppsDropdown from "../Components/Common/WebAppsDropdown";
import FullScreenDropdown from "../Components/Common/FullScreenDropdown";
import NotificationDropdown from "../Components/Common/NotificationDropdown";
import ProfileDropdown from "../Components/Common/ProfileDropdown";
import LightDark from "../Components/Common/LightDark";
import LayoutType from "../Components/Common/LayoutType";
import SideBarType from "../Components/Common/SideBarType";
import Broadcast from "../Components/Common/Broadcast";
import Select from "react-select";
import { isEmpty, clone } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { getBranch, getClient, getCompany, resetBranchState, resetClientState, resetCompanyState, setBranchSelect, setClientSelect, setCompanySelect, setUserType, setUserData, setUserRole } from "../store/actions";

const Header = ({ onChangeLayoutMode, layoutModeType, headerClass, layoutType, onChangeLayout, leftSidebarType, onChangeSidebarTheme }) => {
  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, clients, clientLoading, branches, branchLoading, companies, companyLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
  }));

  const dispatch = useDispatch();

  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [branchList, setBranchList] = useState([]);

  useEffect(() => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    if (obj?.data) {
      if (isEmpty(clientSelected)) dispatch(setClientSelect({ label: obj.data.client_name, value: obj.data.clientId }));
      if (isEmpty(companySelected)) dispatch(setCompanySelect({ label: obj.data.company_name, value: obj.data.companyId }));
      dispatch(setUserData(obj?.data));
      dispatch(setUserType(obj?.data?.userType));
      dispatch(setUserRole(obj?.data?.user?.user_position?.position_role?.method));
      if (isEmpty(clients)) {
        dispatch(resetClientState());
        dispatch(getClient());
      }
      if (isEmpty(companies)) {
        handleGetCompany(obj.data.clientId);
      }
    }
  }, [localStorage.getItem("authUser")]);

  const toogleMenuBtn = () => {
    var windowSize = document.documentElement.clientWidth;
    if (windowSize > 767) document.querySelector(".hamburger-icon").classList.toggle("open");

    if (document.documentElement.getAttribute("data-layout") === "horizontal") {
      document.body.classList.contains("menu") ? document.body.classList.remove("menu") : document.body.classList.add("menu");
    }

    if (document.documentElement.getAttribute("data-layout") === "vertical") {
      if (windowSize < 1025 && windowSize > 767) {
        document.body.classList.remove("vertical-sidebar-enable");
        document.documentElement.getAttribute("data-sidebar-size") === "sm" ? document.documentElement.setAttribute("data-sidebar-size", "") : document.documentElement.setAttribute("data-sidebar-size", "sm");
      } else if (windowSize > 1025) {
        document.body.classList.remove("vertical-sidebar-enable");
        document.documentElement.getAttribute("data-sidebar-size") === "lg" ? document.documentElement.setAttribute("data-sidebar-size", "sm") : document.documentElement.setAttribute("data-sidebar-size", "lg");
      } else if (windowSize <= 767) {
        document.body.classList.add("vertical-sidebar-enable");
        document.documentElement.setAttribute("data-sidebar-size", "lg");
      }
    }

    if (document.documentElement.getAttribute("data-layout") === "twocolumn") {
      document.body.classList.contains("twocolumn-panel") ? document.body.classList.remove("twocolumn-panel") : document.body.classList.add("twocolumn-panel");
    }
  };

  const handleGetCompany = (id) => {
    dispatch(resetCompanyState());
    dispatch(getCompany({ clientId: id }));
  };

  const handleGetBranch = (companyId) => {
    dispatch(resetBranchState());
    dispatch(getBranch({ companyId: companyId, status: 2, visible: true, svg: true }));
  };

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);
    setCompanyList(data);
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    var data = [];
    var opt = userType === "agent" || userType === "agency" ? [] : [{ value: "all", label: "SEMUA PROYEK/CABANG" }];
    (branches || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      const company = item?.branch_company?.name;
      let obj = { label: name, value: id, companyId: item.companyId, company: company, svg_siteplan_project: item.svg_siteplan_project, svg_siteplan: item.svg_siteplan, svg_rincik: item.svg_rincik, branch_code: item.branch_code };
      if (userType === "agent" || userType === "agency") {
        if (item.visibility === "Visible") opt.push(obj);
      }
      else {
        opt.push(obj);
      }
      if (!branchSelected?.value) {
        dispatch(setBranchSelect(obj));
      }
    });
    let option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: "base" })) };
    data.push(option);
    setBranchList(data);
  }, [branches, userType]);

  useEffect(() => {
    if (userType && (userType === "agent" || userType === "agency")) {
      dispatch(getBranch({ status: 2, visible: true, svg: true }));
    }
    else {
      if (companySelected && companySelected.value) {
        handleGetBranch(companySelected.value);
      }
    }
  }, [companySelected, userType]);

  return (
    <React.Fragment>
      <header id="page-topbar" className={headerClass}>
        <div className="layout-width">
          <div className="navbar-header">
            <div className="d-flex pt-0">
              <div className="navbar-brand-box horizontal-logo">
                <Link to="/" className="logo logo-dark">
                  <span className="logo-sm">
                    <img src={logoSm} alt="" height="32" />
                  </span>
                  <span className="logo-lg">
                    <img src={logoDark} alt="" height="28" />
                  </span>
                </Link>

                <Link to="/" className="logo logo-light">
                  <span className="logo-sm">
                    <img src={logoSm} alt="" height="32" />
                  </span>
                  <span className="logo-lg">
                    <img src={logoLight} alt="" height="28" />
                  </span>
                </Link>
              </div>
              <button onClick={toogleMenuBtn} type="button" className="btn btn-sm me-1 ps-0 fs-16 header-item vertical-menu-btn topnav-hamburger shadow-none" id="topnav-hamburger-icon">
                <span className="hamburger-icon">
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
              </button>
              <LanguageDropdown />
              <div className="d-flex gap-3 py-3">
                <Select
                  className="d-none"
                  name="client"
                  value={clientSelected}
                  // isDisabled={userType === "admin" || userType === "client" ? false : true}
                  placeholder="Pilih Grup Usaha"
                  onChange={(e) => {
                    setCompanyList([]);
                    setBranchList([]);
                    dispatch(setCompanySelect(null));
                    dispatch(setBranchSelect(null));
                    dispatch(setClientSelect(e));
                    handleGetCompany(e.value);
                  }}
                  options={clientList}></Select>
                <div className={userType === "agent" ? "d-none" : ""}>
                  <Select
                    name="company"
                    className=""
                    value={companySelected}
                    isDisabled={userType === "admin" || userType === "client" || userType === "holding" ? false : true}
                    placeholder="Pilih Perusahaan"
                    onChange={(e) => {
                      setBranchList([]);
                      dispatch(setBranchSelect(null));
                      dispatch(setCompanySelect(e));
                      handleGetBranch(e.value);
                    }}
                    options={companyList}></Select>
                </div>
                <div style={{ minWidth: "260px" }}>
                  <Select
                    name="branch"
                    className="w-100"
                    value={branchSelected}
                    placeholder="PILIH CABANG / PROYEK"
                    onChange={(e) => {
                      dispatch(setBranchSelect(e));
                      if (e.value !== "all") dispatch(setCompanySelect({ label: e.company, value: e.companyId }));
                    }}
                    options={branchList}></Select>
                </div>
                {branchLoading && <Spinner className="mt-2" color="primary" size="sm">
                  Loading...
                </Spinner>}
              </div>

              {/* <SearchOption /> */}
            </div>

            <div className="d-flex align-items-center">
              {/* 
                <Dropdown isOpen={search} toggle={toogleSearch} className="d-md-none topbar-head-dropdown header-item">
                    <DropdownToggle type="button" tag="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle">
                        <i className="bx bx-search fs-22"></i>
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
                        <Form className="p-3">
                            <div className="form-group m-0">
                                <div className="input-group">
                                    <input type="text" className="form-control" placeholder="Search ..."
                                        aria-label="Recipient's username" />
                                    <button className="btn btn-primary" type="submit"><i
                                        className="mdi mdi-magnify"></i></button>
                                </div>
                            </div>
                        </Form>
                    </DropdownMenu>
                </Dropdown>
                */}

              {/* NotificationDropdown */}
              {/* LanguageDropdown */}

              {/* FullScreenDropdown */}
              <FullScreenDropdown />

              {/* LayoutType <SideBarType sidebarType={leftSidebarType} onChangeSidebarTheme={onChangeSidebarTheme} /> */}


              {/* LayoutType */}
              <LayoutType layouttype={layoutType} onChangeLayout={onChangeLayout} />

              {/* Dark/Light Mode set */}
              <LightDark layoutMode={layoutModeType} onChangeLayoutMode={onChangeLayoutMode} />
              {userType !== "agent" && <Broadcast />}

              <NotificationDropdown />

              {/* ProfileDropdown */}
              <ProfileDropdown />
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default Header;
